import { render, staticRenderFns } from "./Shareholder-edit-company-form.vue?vue&type=template&id=0e3a0138"
import script from "./Shareholder-edit-company-form.vue?vue&type=script&lang=js"
export * from "./Shareholder-edit-company-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports